import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import type { StageDiscipline } from '../types';
import SectionShell, { formatSeconds } from './SectionShell';

/** The call's path through opening, discovery, pitch and close, with time in each. */
const StageDisciplineSection: React.FC<{ data?: StageDiscipline }> = ({ data }) => {
  if (!data) return null;
  return (
    <SectionShell title="Call Flow" score={data.overallScore} summary={data.overallSummary}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
        {data.stages?.map((stage, idx) => (
          <React.Fragment key={stage.stage}>
            {idx > 0 && <Typography color="text.secondary" aria-hidden="true">›</Typography>}
            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, px: 1.5, py: 1 }}>
              <Typography variant="subtitle2">{stage.label}</Typography>
              <Typography variant="caption" color="text.secondary">
                {formatSeconds(stage.secondsSpent)}
              </Typography>
              {stage.wasForced && (
                <Chip label="moved on by the clock" size="small" variant="outlined" sx={{ ml: 1 }} />
              )}
            </Box>
          </React.Fragment>
        ))}
      </Stack>
      {data.skippedDiscovery && (
        <Typography variant="body2" color="warning.main" mt={2}>
          Discovery was skipped: the rep pitched before learning the customer's situation.
        </Typography>
      )}
    </SectionShell>
  );
};

export default StageDisciplineSection;
